import { getLocale, setLocale } from 'src/locales/util';

export default {
    get(key: string) {
        // if(globalThis.localStorage){
        //     // return globalThis.localStorage.getItem(key) || ''
        //     return globalThis.localStorage.getItem('locale') || ''
        // }
        // return ''
        return getLocale();
    },
    set(key: string, value: any) {
        // if(globalThis.localStorage){
        //     globalThis.localStorage.setItem(key,value)
        // }
        setLocale(value, true);
    },
    remove(key: string) {
        // if(globalThis.localStorage){
        //     globalThis.localStorage.removeItem(key)
        // }
        window.localStorage.removeItem('locale');
    }
};